// import

import {styled} from 'goober';
import * as R from 'ramda';
import type {ComponentProps} from 'react';

import type {PostNode} from 'libs/model';

import {RelatedPost} from './RelatedPost';

// types

type Props = ComponentProps<typeof Nav> & {
  nodes: PostNode[];
};

// component

export function RelatedPosts(props: Props) {
  const {nodes, ...rest} = props;

  if (nodes.length < 2) {
    return null;
  }

  return (
    <Nav {...rest} data-ix={R.range(1, nodes.length + 1).join('')}>
      {nodes.slice(0, 8).map((node) => (
        <RelatedPost key={node.meta.slug} className="post" node={node} />
      ))}
    </Nav>
  );
}

// styles

const Nav = styled('nav')`
  display: grid;
  justify-content: center;
  align-items: stretch;
  justify-items: stretch;
  gap: 2rem;
  grid-auto-rows: auto;
  margin: 7.5rem auto 0;
  max-width: var(--bp-xxl);

  @media (min-width: 72em) {
    &[data-ix$="2"] {
      max-width: var(--bp-m);
      grid-template-columns: 1fr 1fr;
    }

    &[data-ix$="3"] {
      grid-template-columns: 1fr 1fr 1fr;
    }

    &[data-ix*="4"] {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    &[data-ix$="5"], &[data-ix$="6"], &[data-ix$="7"] {
      & .post:nth-child(n + 5) { display: none; }
    }

    &[data-ix*="8"] {
      & .post:nth-child(n + 9) { display: none; }
    }
  }

  @media (min-width: 54em) and (max-width: 71.99875em) {
    &[data-ix$="2"] {
      max-width: var(--bp-m);
      grid-template-columns: 1fr 1fr;
    }

    &[data-ix*="3"] {
      grid-template-columns: 1fr 1fr 1fr;
    }

    &[data-ix$="4"], &[data-ix$="5"] {
      & .post:nth-child(n + 4) { display: none; }
    }

    &[data-ix*="6"] {
      & .post:nth-child(n + 7) { display: none; }
    }
  }

  @media (min-width: 36em) and (max-width: 53.99875em) {
    gap: 1.5rem;

    grid-template-columns: 1fr 1fr;
    & .post:nth-child(n + 5) { display: none; }

    &[data-ix$="3"] {
      & .post:nth-child(n + 3) { display: none; }
    }
  }

  @media (max-width: 35.99875em) {
    gap: 1rem;

    grid-template-columns: 1fr;
    & .post:nth-child(n + 4) { display: none; }
  }
`;
